<script lang="ts">
    import { Circle } from "svelte-loading-spinners"

    export let active = false,
        styles: string = "",
        progress: number = null,
        classList = ""
</script>

<div
    class="loadingWrapper"
    class:active="{active}"
>
    {#if active}
        <div class="spinner">
            <Circle
                size="2"
                color="#741e20"
                unit="rem"
            />
            {#if !isNaN(progress) && progress !== null}
                <span>{Math.round(progress)} %</span>
            {/if}
        </div>
    {/if}
    <div
        class="content {classList}"
        style="{styles}"
    >
        <slot />
    </div>
</div>

<style lang="less">
    .loadingWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px;
        margin: 0px;
        width: 100%;
        .content {
            width: 100%;
        }

        &.active {
            pointer-events: none;
        }
        .spinner {
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1.2rem;
            span {
                color: var(--text-invers-100);
                font-size: 1.2rem;
            }
        }
        &.active {
            .content {
                opacity: 0.5;
            }
        }
    }
</style>
